export default "__VITE_ASSET__CDjcQUbI__"